import {getAllBAU,
  createIndexManaging,
    editIndex,
    getBAUDetail,
    EditIndexManaging,
    getIndexDetail,
    getBank,
    getAllCategory,
    addCategory,
    editCategory,
    deleteCategory,
    getAllReportingPeriodByTenantId,
    getAllMeasurementUnitByTenantId,
    deleteIndex,
    acceptIndex,
    getAllKeyResyltByTeamId,
    getAllKeyResyltByPersonId,
    deleteIndexManaging,
    GetAllOKRStateByTenantId,
    getAllObjectiveDefinitionLevelByTenantId,
    getAllCategoriesTenantId,
    getAllMyTeamByTenantId,
    getAllTeamsByTenantId,
    getAlBrothersByTeamId,
    getAllObjectivesByPeriodId
} from '../Api/Index';

import { GetAllActivePersonByTenantId, GetAllBrothersPersonByTeamId,GetBrothersPersonByTeamId } from '../../OKRManagment/Api';
import { useQuery, useQueryClient, useMutation } from "react-query";

type option = {
    id: string;
    name: string;
  };

const useGetAllBAU=(tenantId: string | null,periodId : string | null)=>{
    return useQuery(['getAllBAU', tenantId,periodId],getAllBAU,{
      enabled: !!tenantId,
        refetchOnWindowFocus:false,
        cacheTime:Infinity,
        onError:(err)=>{
        },
        onSuccess:(data)=>{
            // let rawdata=data?.data?.data;
        }
        ,
        select:(data)=>{
            let rawdata=data?.data;
             return rawdata
        }
    })
}

const useGetBAUDetail=(id: string | null)=>{
  return useQuery(['getBAUDetail', id],getBAUDetail,{
    enabled: !! id,
      refetchOnWindowFocus:false,
      cacheTime:Infinity,
      onError:(err)=>{
      },
      onSuccess:(data)=>{
          // let rawdata=data?.data?.data;
      }
      ,
      select:(data)=>{
          let rawdata=data?.data?.data;
           return rawdata
      }
  })
}

const useGetAllObjectiveOKRStateByTenantId = (tenantId: string | null) => {
  return useQuery(
    ["GetAllOKRStateByTenantId", tenantId],
    GetAllOKRStateByTenantId,
    {
      enabled: !!tenantId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onError: (err) => {
        console.log(err);
      },
      select: (data : any) => {
        let rawData = data?.data?.data;
        let transformed = rawData
          .map((item: any) => {
            let { id, name } = item;
            return { id, label: name };
          })
          .filter((item: any) => item.label !== "بسته شده");
        return transformed;
      },
    }
  );
};

const useGetAllObjectiveDefinitionLevelByTenantId = (
  tenantId: string | null
) => {
  return useQuery(
    ["getAllObjectiveDefinitionLevelByTenantId", tenantId],
    getAllObjectiveDefinitionLevelByTenantId,
    {
      enabled: !!tenantId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onError: (err: any) => {},
      select: (data: any) => {
        let rawData = data?.data?.data;
        //  console.log(rawData)
        let transformed = rawData.map((item: any) => {
          let { name: key, id: value, isCompany } = item;
          return { key, value, isCompany };
        });
        return transformed;
      },
    }
  );
};

const useGetAllMyTeamByTenantId = (
  tenantId: string | null,
  teamId: string | null
) => {
  return useQuery(
    ["getAllMyTeamByTenantId", tenantId,teamId],
    getAllMyTeamByTenantId,
    {
      enabled: !!tenantId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onError: (err: any) => {},
      select: (data: any) => {
        let rawData = data?.data?.data;
        //  console.log(rawData)
        let transformed = rawData.map((item: any) => {
          let { name: key, id: value, isCompany } = item;
          return { key, value, isCompany };
        });
        return transformed;
      },
    }
  );
};

const useGetAlBrothersByTeamId = (
  tenantId: string | null
) => {
  return useQuery(
    ["getAlBrothersByTeamId", tenantId],
    getAlBrothersByTeamId,
    {
      enabled: !!tenantId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onError: (err: any) => {},
      select: (data: any) => {
        let rawData = data?.data?.data;
        //  console.log(rawData)
        let transformed = rawData.map((item: any) => {
          let { name: key, id: value, isCompany } = item;
          return { key, value, isCompany };
        });
        return transformed;
      },
    }
  );
};

const useGetAllTeamsByTenantId = (
  tenantId: string | null
) => {
  return useQuery(
    ["getAllTeamsByTenantId", tenantId],
    getAllTeamsByTenantId,
    {
      enabled: !!tenantId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onError: (err: any) => {},
      select: (data: any) => {
        let rawData = data?.data?.data;
        //  console.log(rawData)
        let transformed = rawData.map((item: any) => {
          let { name: key, id: value, isCompany } = item;
          return { key, value, isCompany };
        });
        return transformed;
      },
    }
  );
};

const useGetAllObjectivesByPeriodId = (
  tenantId: string | null,
  periodId: string | null
) => {
  return useQuery(
    ["getAllObjectivesByPeriodId", tenantId, periodId],
    getAllObjectivesByPeriodId,
    {
      enabled: !!tenantId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onError: (err: any) => {},
      select: (data: any) => {
        let rawData = data?.data?.data;
        //  console.log(rawData)
        let transformed = rawData.map((item: any) => {
          let { name: key, id: value, isCompany } = item;
          return { key, value, isCompany };
        });
        return transformed;
      },
    }
  );
};

const useGetAllKeyResyltByTeamId = (
  tenantId: string | null,
  periodId: string | null,
  teamId: string | null,
) => {
  return useQuery(
    ["getAllKeyResyltByTeamId", tenantId, periodId,teamId],
    getAllKeyResyltByTeamId,
    {
      enabled: !!tenantId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onError: (err: any) => {},
      select: (data: any) => {
        let rawData = data?.data?.data;
        //  console.log(rawData)
        let transformed = rawData.map((item: any) => {
          let { name: key, id: value, isCompany } = item;
          return { key, value, isCompany };
        });
        return transformed;
      },
    }
  );
};

const useGetAllKeyResyltByTeamId10 = (
  tenantId: string | null,
  periodId: string | null
) => {
  return useQuery(
    ["getAllKeyResyltByPersonId", tenantId, periodId],
    getAllKeyResyltByPersonId,
    {
      enabled: !!tenantId,
      cacheTime: Infinity,
      refetchOnWindowFocus: false,
      onError: (err: any) => {},
      select: (data: any) => {
        let rawData = data?.data?.data;
        let transformed = rawData.map(({ name, id }: any,i:number) => {
          return { key:  (i+1) + "." + name + "      ", value: id };
        });
        return transformed;
      },
    }
  );
};


const useGetAllReportingPeriodByTenantId=(tenantId: string | null)=>{
  return useQuery(['getAllReportingPeriodByTenantId', tenantId],getAllReportingPeriodByTenantId,{
    enabled: !!tenantId,
      refetchOnWindowFocus:false,
      cacheTime:Infinity,
      onError:(err)=>{
      },
      onSuccess:(data)=>{
          // let rawdata=data?.data?.data;
      }
      ,
      select: (data: any) => {
        let rawData = data?.data?.data;
        let tranFormed;
        if (rawData) {
          tranFormed = rawData.map(({ name, id,description }: any) => {
            return { key: name, value: id ,desc: description};
          });
        }
        return tranFormed;
      },
  })
}

const useGetAllMeasurementUnitByTenantId=(tenantId: string | null)=>{
  return useQuery(['getAllMeasurementUnitByTenantId', tenantId],getAllMeasurementUnitByTenantId,{
    enabled: !!tenantId,
      refetchOnWindowFocus:false,
      cacheTime:Infinity,
      onError:(err)=>{
      },
      onSuccess:(data)=>{
          // let rawdata=data?.data?.data;
      }
      ,
      select: (data: any) => {
        let rawData = data?.data?.data;
        let tranFormed;
        if (rawData) {
          tranFormed = rawData.map(({ name, id }: option) => {
            return { key: name, value: id };
          });
        }

        return tranFormed;
      },
  })
}

const useGetAllReportingPeriodByTenantId1=(tenantId: string | null)=>{
  return useQuery(['getAllReportingPeriodByTenantId', tenantId],getAllReportingPeriodByTenantId,{
    enabled: !!tenantId,
      refetchOnWindowFocus:false,
      cacheTime:Infinity,
      onError:(err)=>{
      },
      onSuccess:(data)=>{
          // let rawdata=data?.data?.data;
      }
      ,
      select: (data: any) => {
        let rawData = data?.data;
        // let tranFormed;
        // if (rawData) {
        //   tranFormed = rawData.map(({ value, id }: option) => {
        //     return { key: value, value: id };
        //   });
        // }

        return rawData;
      },
  })
}

const useGetAllMeasurementUnitByTenantId1=(tenantId: string | null)=>{
  return useQuery(['getAllMeasurementUnitByTenantId', tenantId],getAllMeasurementUnitByTenantId,{
    enabled: !!tenantId,
      refetchOnWindowFocus:false,
      cacheTime:Infinity,
      onError:(err)=>{
      },
      onSuccess:(data)=>{
          // let rawdata=data?.data?.data;
      }
      ,
      select: (data: any) => {
        let rawData = data?.data;
        // let tranFormed;
        // if (rawData) {
        //   tranFormed = rawData.map(({ value, id }: option) => {
        //     return { key: value, value: id };
        //   });
        // }

        return rawData;
      },
  })
}
//    const useGetIndexDetail=(userData:any)=>{
//     // const queryClient=useQueryClient()
//     return useMutation({
//   mutationFn: () =>getIndexDetail(userData),
//   onSuccess: (data:any) => {
//     let rawData = data?.data;
//           // let tranFormed;
//           // if (rawData) {
//           //   tranFormed = rawData.map(({ name, id }: option) => {
//           //     return { key: name, value: id };
//           //   });
//           // }
//           return rawData;
//   },
// });
//    }

// const useGetIndexDetail=(tenantId: string | null)=>{
//   return useQuery(['getAllCategoriesTenantId', tenantId],getAllCategoriesTenantId,{
//     enabled: !!tenantId,
//       refetchOnWindowFocus:false,
//       cacheTime:Infinity,
//       onError:(err)=>{
//       },
//       onSuccess:(data)=>{
//           let rawdata=data?.data?.data;
//       }
//       ,
//       select:(data)=>{
//           let rawdata=data?.data;
//            return rawdata
//       }
//   })
// }

  //  const useGetIndexDetail = (userData:any) => {
  //   return useQuery(
  //     [
  //       // "getAllCategoriesTenantId",
  //        userData],
  //     getIndexDetail,
  //     {
  //       enabled: !!userData,
  //       cacheTime: Infinity,
  //       refetchOnWindowFocus: false,
  //       onSuccess: (data) => {
  //         //    console.log(data)
  //       },
  //       onError: (err: any) => {
  //         //    console.log(err)
  //       },
  //       select: (data: any) => {
  //         let rawData = data?.data;
  //         // let tranFormed;
  //         // if (rawData) {
  //         //   tranFormed = rawData.map(({ name, id }: option) => {
  //         //     return { key: name, value: id };
  //         //   });
  //         // }
  //         return rawData;
  //       },
  //     }
  //   );
  // };

  const useGetIndexDetail=(tenantId: string | null)=>{
    return useQuery(['getIndexDetail', tenantId],getIndexDetail,{
      enabled: !!tenantId,
        refetchOnWindowFocus:false,
        cacheTime:Infinity,
        onError:(err)=>{
        },
        onSuccess:(data)=>{
            // let rawdata=data?.data?.data;
        }
        ,
        select:(data)=>{
            let rawdata=data?.data;
             return rawdata
        }
    })
}

   const useGetAllCategoriesTenantId = (tenantId: string | null) => {
    return useQuery(
      ["getAllCategoriesTenantId", tenantId],
      getAllCategoriesTenantId,
      {
        enabled: !!tenantId,
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
          //    console.log(data)
        },
        onError: (err: any) => {
          //    console.log(err)
        },
        select: (data: any) => {
          let rawData = data?.data;
          // let tranFormed;
          // if (rawData) {
          //   tranFormed = rawData.map(({ name, id }: option) => {
          //     return { key: name, value: id };
          //   });
          // }
          return rawData;
        },
      }
    );
  };
  
  const useAddCategory=()=>{
    const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (userData:any) =>addCategory(userData),
  onSuccess: (data:any) => {
    queryClient.invalidateQueries('getAllCategoriesTenantId')
  },
});
   }

   const useEditCategory=()=>{
    const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (userData:any) =>editCategory(userData),
  onSuccess: (data:any) => {
    queryClient.invalidateQueries('getAllCategoriesTenantId')
  },
});
   }

  const useGetBank=(tenantId: string | null)=>{
    return useQuery(['getBank', tenantId],getBank,{
      enabled: !!tenantId,
        refetchOnWindowFocus:false,
        cacheTime:Infinity,
        onError:(err)=>{
        },
        onSuccess:(data)=>{
            // let rawdata=data?.data?.data;
        }
        ,
        select:(data)=>{
            let rawdata=data?.data;
             return rawdata
        }
    })
}

const useDeleteIndexManaging1=()=>{
  const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (data:any) =>deleteIndexManaging(data),
  onSuccess: (data) => {
      queryClient.invalidateQueries('getAll')
  },
});
}

const useDeleteIndexManaging=()=>{
  const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (data:any) =>deleteIndexManaging(data),
  onSuccess: (data) => {
      queryClient.invalidateQueries('getAllBAU')
  },
});
}

const useDeleteIndex=()=>{
  const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (data:any) =>deleteIndex(data),
  onSuccess: (data) => {
      queryClient.invalidateQueries('getAll')
  },
});
}

const useAcceptIndex=()=>{
    const queryClient=useQueryClient()
      return useMutation({
    mutationFn: (data:any) =>acceptIndex(data),
    onSuccess: (data) => {
        queryClient.invalidateQueries('getAll')
    },
  });
  }

  const useCreateIndexManaging=()=>{
    const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (userData:any) =>createIndexManaging(userData),
  onSuccess: (data:any) => {
    queryClient.invalidateQueries('useGetAllBAU')
  },
});
   }

   const useEditIndexManaging=()=>{
    const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (userData:any) =>EditIndexManaging(userData),
  onSuccess: (data:any) => {
    queryClient.invalidateQueries('useGetAllBAU')
  },
});
   }

   const useGetAllActivePersonByTenantId = (tenantId: string | null) => {
    return useQuery(
      ["GetAllActivePersonByTenantId", tenantId],
      GetAllActivePersonByTenantId,
      {
        enabled: !!tenantId,
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
          //    console.log(data)
        },
        onError: (err: any) => {
          //    console.log(err)
        },
        select: (data: any) => {
          let rawData = data?.data?.data;
          let tranFormed;
          if (rawData) {
            tranFormed = rawData.map(({ name, id }: option) => {
              return { key: name, value: id };
            });
          }
  
          return tranFormed;
        },
      }
    );
  };
  

  const useGetAllPersonByTenantId = (tenantId: string | null) => {
    return useQuery(
      ["GetAllActivePersonByTenantId", tenantId],
      GetAllActivePersonByTenantId,
      {
        enabled: !!tenantId,
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
          //    console.log(data)
        },
        onError: (err: any) => {
          //    console.log(err)
        },
        select: (data: any) => {
          let rawData = data?.data?.data; 
          return rawData;
        },
      }
    );
  };

  const useGetAllBrothersPersonByTeamId = (tenantId: string | null) => {
    return useQuery(
      ["GetAllBrothersPersonByTeamId", tenantId],
      GetAllBrothersPersonByTeamId,
      {
        enabled: !!tenantId,
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
          //    console.log(data)
        },
        onError: (err: any) => {
          //    console.log(err)
        },
        select: (data: any) => {
          let rawData = data?.data?.data; 
          return rawData;
        },
      }
    );
  };

  const useGetBrothersPersonByTeamId = (tenantId: string | null) => {
    return useQuery(
      ["GetBrothersPersonByTeamId", tenantId],
      GetBrothersPersonByTeamId,
      {
        enabled: !!tenantId,
        cacheTime: Infinity,
        refetchOnWindowFocus: false,
        onSuccess: (data) => {
          //    console.log(data)
        },
        onError: (err: any) => {
          //    console.log(err)
        },
        select: (data: any) => {
          let rawData = data?.data?.data; 
          return rawData;
        },
      }
    );
  };

export{
    useGetAllBAU,
    useGetBAUDetail,
    useGetAllBrothersPersonByTeamId,
    useGetAllObjectiveOKRStateByTenantId,
    useGetAllObjectiveDefinitionLevelByTenantId,
    useGetAllActivePersonByTenantId,
    useGetBrothersPersonByTeamId,
    useGetAllReportingPeriodByTenantId,
    useGetAllReportingPeriodByTenantId1,
    useGetAllMeasurementUnitByTenantId1,
    useGetAllMeasurementUnitByTenantId,
    useGetAllKeyResyltByTeamId,
    useGetAllObjectivesByPeriodId,
    // useDeleteCategory,
    // useGetAllCategoriesTenantId,
    useCreateIndexManaging,
    useGetAllMyTeamByTenantId,
    useDeleteIndexManaging,
    useEditIndexManaging,
    useGetAllTeamsByTenantId,
    getAllMyTeamByTenantId,
    useGetAllPersonByTenantId,
    useGetAllKeyResyltByTeamId10,
    useGetAlBrothersByTeamId
    // useGetIndexDetail,
    // useAddCategory,
    // useDeleteIndex,
    // useEditCategory,
    // useGetAllCategory,
    // useEditIndex,
    // useAcceptIndex,
    // useGetBank
}